import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0a0598c1&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./assets/index.response.css?vue&type=style&index=0&id=0a0598c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0598c1",
  null
  
)

export default component.exports